import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ExpenseService } from 'app/services/models/expense.service';
import { KindService } from 'app/services/models/kind.service';
import { MainExpenseService } from 'app/services/models/main-expense.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-expense-create',
  templateUrl: './expense-create.component.html',
  styleUrls: ['./expense-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseCreateComponent implements OnInit, OnChanges {
  @Input() expense: any;
  expenseForm: FormGroup;
  kinds: any[] = [];
  mainExpenses: any[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private _coreSidebarService: CoreSidebarService,
    private kindService: KindService,
    private expenseService: ExpenseService,
    private toastrService: ToastrService,
    private mainExpenseService: MainExpenseService) {

    this.expenseForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      kindId: [null, [Validators.required]],
      mainExpenseId: [null,[Validators.required]]
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.expense);
    this.expenseForm.patchValue({
      name: this.expense.name,
      kindId: this.expense.kindId,
      mainExpenseId : this.expense.mainExpenseId
    });
  }

  async ngOnInit() {

    await this.getAllKinds();
    await this.getAllMainExpense();
  }

  async getAllMainExpense() {
    const data = await this.mainExpenseService.getAll();
    this.mainExpenses = data;
    console.log(this.mainExpenses);
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 10, 11);
    console.log(data);
    this.kinds = data.types;
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async onSubmit() {
    if (this.expenseForm.valid) {
      console.log(this.expenseForm.value);
      if (this.expense) {
        const data = await this.expenseService.updateExpense(this.expense.id, this.expenseForm.value.name, this.expenseForm.value.kindId,this.expenseForm.value.mainExpenseId
        );
        if (data.status) {
          this.toggleSidebar('create-expense');
          this.expenseService.sendEvent(true);
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.expenseService.createExpense(this.expenseForm.value.name, this.expenseForm.value.kindId,this.expenseForm.value.mainExpenseId);
        if (data.status == true) {
          this.toggleSidebar('create-expense');
          this.expenseService.sendEvent(true);
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }
}
